import React, { type FunctionComponent, useMemo } from 'react'
import { css } from '@emotion/react'
import { colors } from '@retailer-platform/shared-components'
import RowHeader from 'domains/shifts/components/RowHeader'
import { StaffingLevelCell } from 'domains/shifts/components/components/staffing-levels/StaffingLevelCell'
import { getStaffingLevelsForShiftType } from 'domains/shifts/components/components/staffing-levels/utils/getStaffingLevelsForShiftType'
import {
  type StaffingLevel,
  type StaffingLevelData,
} from 'domains/shifts/components/components/staffing-levels/utils/types'
import { useShiftsStateContext } from 'domains/shifts/components/contexts/ShiftsStateContext'

interface WeeklyStaffingLevelsRowProps {
  staffingLevels: StaffingLevel[]
  label: string
  sublabel: string
  openingHourOffset: number
  closingHourOffset: number
}

const FILLER_CELL = {
  filler: true,
  scheduled: 0,
  required: 0,
  closed: true,
}

const containerStyles = css({
  display: 'flex',
  height: '48px',
  borderBottom: `2px solid ${colors.GRAYSCALE.X0}`,
})

export const WeeklyStaffingLevelsRow: FunctionComponent<WeeklyStaffingLevelsRowProps> = ({
  staffingLevels,
  label,
  sublabel,
  openingHourOffset,
  closingHourOffset,
}) => {
  const {
    shiftsState: { shiftType },
  } = useShiftsStateContext()
  const levels: StaffingLevelData[] = useMemo(() => {
    const levels = getStaffingLevelsForShiftType(staffingLevels, shiftType)

    for (let i = 0; i < openingHourOffset; i++) {
      levels.unshift(FILLER_CELL)
    }
    for (let i = 0; i < closingHourOffset; i++) {
      levels.push(FILLER_CELL)
    }

    return levels
  }, [staffingLevels, shiftType, openingHourOffset, closingHourOffset])

  return (
    <div css={containerStyles}>
      <RowHeader label={label} sublabel={sublabel} isWeeklyView={true} />

      {levels.map(({ scheduled, required, closed }, i) => (
        <StaffingLevelCell
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          scheduled={scheduled}
          required={required}
          closed={closed}
          isWeeklyView
        />
      ))}
    </div>
  )
}
